import { Component, OnInit } from '@angular/core';
import { getEmptyQuestion, Question } from 'src/app/interfaces/question';
import { QuestionService } from 'src/app/services/question.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-wizard-question-edit',
  templateUrl: './wizard-question-edit.component.html',
  styleUrls: ['./wizard-question-edit.component.scss'],
})
export class WizardQuestionEditComponent implements OnInit {
  question: any;
  internTyp: any[] = ["Event", "Location", "Date"]
  constructor(
    private questionS: QuestionService,
    private toastS: ToastService
  ) {
    this.questionS.QDataSubject.subscribe(q => {
      this.question = q;
    })
  }

  ngOnInit() { }


  save() {
    this.questionS.saveQuestion(this.question).subscribe(x => {
      this.questionS.QSave.next(x);
      //TODO: toastmessage
      this.toastS.addToast();
      console.log("user wurde gespeichert", this.question);
    }, err => {
      this.toastS.addToastNot();
      console.log("user wurde nicht gespeichert", this.question);
    });
  }

}
